var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8578 14.0866V11.7864C5.85779 11.2036 6.33175 10.73 6.91883 10.7264H9.07446C9.66416 10.7264 10.1422 11.201 10.1422 11.7864V14.0799C10.1422 14.5855 10.553 14.9963 11.0622 15H12.5329C13.2197 15.0017 13.8791 14.7321 14.3654 14.2505C14.8517 13.769 15.125 13.1151 15.125 12.4331V5.89938C15.125 5.34854 14.8791 4.82603 14.4535 4.47263L9.45723 0.505701C8.58388 -0.188158 7.33653 -0.165744 6.48904 0.559038L1.60026 4.47263C1.15456 4.81562 0.888164 5.33967 0.875 5.89938V12.4265C0.875 13.8478 2.03554 15 3.46713 15H4.90422C5.14938 15.0018 5.38512 14.9063 5.5591 14.7348C5.73309 14.5633 5.83094 14.33 5.83094 14.0866H5.8578Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f65b0c89658b6691c04bd9e5aafba8d1.svg";
export { ForwardRef as ReactComponent };